// Pull in client here rather than in fetchSubscriptionProducts to remove possible
// circular dependency if we're using the mockClient in services
import { getClient } from "services";

import {
  makeFetchSubscriptionProducts,
  makeFetchSubscriptionProductsIfNotFetched
} from "./fetchSubscriptionProducts";

const getSubscriptionServiceClient = () => getClient("subscriptionService");

export const fetchSubscriptionProducts = makeFetchSubscriptionProducts(
  getSubscriptionServiceClient
);

export const fetchSubscriptionProductsIfNotFetched =
  makeFetchSubscriptionProductsIfNotFetched(getSubscriptionServiceClient);
